const support_options_list = [
  {
    config: "1",
    value: "1",
    label: "r_enable",
    id: "support_enable",
  },
  {
    config: "0",
    value: "0",
    label: "r_disable",
    id: "support_disable",
  },
];

export const support = {
  enable: support_options_list,
};

export default support;
